<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>
    <el-dialog
      :before-close="handleClose"
      title="选择单位性质"
      :visible.sync="showType"
      width="400px"
      top="30vh"
      :show-close="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="单位性质:" prop="unitNature" :rules="{required: true,message:'单位性质不能为空'}">
          <el-radio-group v-model="form.unitNature">
            <el-radio :label="1">生产单位</el-radio>
            <el-radio :label="2">检测检验机构</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button type="primary" @click="onSumbit">确 定</el-button>
        <el-button type="info" @click="handleClose">退出登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {AppMain, Navbar, Sidebar, TagsView} from './components'
import ResizeMixin from './mixin/ResizeHandler'
import {mapState} from 'vuex'
import store from '@/store'
import {getUnitNature, updataUnitNature} from '@/api/user'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  data() {
    return {
      showType: false,
      form: {}
    }
  },
  created() {
    this.getUnitType()
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    getUnitType() {
      console.log(store.getters.userInfo, ' store.getters')
      if (store.getters.userInfo.roleId === '6') {
        getUnitNature().then(res => {
          if (res.data) {
            this.showType = true
          }
        })
      }
    },
    onSumbit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {
            unitId: store.getters.id,
            unitNature: this.form.unitNature
          }
          updataUnitNature(data).then(res => {
            this.$message.success('确认成功')
            this.showType = false
          })
        }
      })
    },
    handleClose() {
      this.$store.dispatch('user/logout')
        .then(() => {
          this.$router.push({ path: '/login' })
          this.showType = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
